const dropdowns = document.querySelectorAll('[data-filter-dropdown]');
let filterDropdownToggled = false;

dropdowns.forEach((element, index, elements) => {
    element.addEventListener("keydown", (event) => filterHandleButtonKey(event, element, index, elements));
    element.addEventListener("click", (event) => toggleDropdownMenu(element));
});

// Sluit zoekformulier bij esc button
document.body.addEventListener('keydown', function(e) {
    if (e.key == "Escape" && filterDropdownToggled === true) {
        
        for (var i = 0; i < dropdowns.length; ++i) {
            dropdowns[i].setAttribute("aria-expanded", "false");
            dropdowns[i].classList.remove('fs-open');
            dropdowns[i].querySelector(".fs-dropdown").classList.add("fs-hidden");
        }
    }
});


function filterHandleButtonKey(event, element, index, elements) {
    const key = event.key;

    switch (key) {
        case "Enter":
        case " ":
            if (element.classList.contains('custom-fs-wrap')) {
                event.preventDefault();
                toggleDropdownMenu(element);
            }
            break;
    }
}


function toggleDropdownMenu(element) {

    const isExpanded = element.getAttribute("aria-expanded") === "true";

    for (var i = 0; i < dropdowns.length; ++i) {
        if (isExpanded) {
            dropdowns[i].setAttribute("aria-expanded", "false");
        } else {
            dropdowns[i].setAttribute("aria-expanded", "true");
        }
    }

    if (isExpanded) {
        // Sluit het dropdownmenu
        element.setAttribute("aria-expanded", "false");
        element.classList.remove('fs-open');
        element.querySelector(".fs-dropdown").classList.add("fs-hidden");
        filterDropdownToggled = false;
    } else {
        // Open het dropdownmenu
        element.setAttribute("aria-expanded", "true");
        element.classList.add('fs-open');
        element.querySelector(".fs-dropdown").classList.remove("fs-hidden");
        filterDropdownToggled = true;
    }
}

document.addEventListener('facetwp-refresh', function() {
    if (FWP.facets['lengte'] !== undefined && Array.isArray(FWP.facets['lengte'])) {
        let label = document.querySelector('.custom-facet-dropdown-lengte .fs-label');

        if (FWP.facets['lengte'].length) {
            label.innerHTML = 'Lengte <span class="fs-custom-counter">1</span>';
        } else {
            label.innerHTML = 'Lengte';
        }
    }
});

window.addEventListener('DOMContentLoaded', (event) => {
    let button = document.querySelector('[data-filter-toggle]');
    let target = document.querySelector('[data-filter-toggle-target]');
    
    if (button && target) {
        button.onclick = function() {

            const isExpandedMobile = button.getAttribute("aria-expanded") === "true";

            if (isExpandedMobile) {
                // Sluit het submenu
                target.classList.remove('open');
                button.setAttribute("aria-expanded", "false");
                target.setAttribute("aria-hidden", "true");
            } else {
                // Open het geselecteerde submenu
                target.classList.add('open');
                button.setAttribute("aria-expanded", "true");
                target.setAttribute("aria-hidden", "false");
            }
        }
    }
});
